import styled from "styled-components";

export const StyledHome = styled.div`
  padding: 120px 0px 40px 70px;
  display: flex;
`;

export const MainSection = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 905px;
`;

export const RightNav = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 175px;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 160px;

  > *:first-child {
    margin-bottom: 10px;
  }
`;

export const Button = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${props => (props.primary ? "#5d69e6" : "transparent")};
  border-radius: 20.5px;
  border-style: solid;
  border: ${props => (props.primary ? null : "none")};
  width: 160px;
  height: 40px;
  color: ${props => (props.primary ? "#ffffff" : "#5d69e6")};
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: -0.1px;
  line-height: 14px;
  cursor: pointer;

  svg {
    width: 24px;
    height: 24px;
    margin-right: 8px;
  }

  &:focus {
    outline: none;
  }
`;
